module.exports = __webpack_public_path__ + "static/media/caredose.7d4dd394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caredose.png
// module id = 1276
// module chunks = 0